import { Box, Typography, useMediaQuery } from '@mui/material';
import { FormInput } from '~/components/FormComponents/FormInput';
import { TExplanationAnswer } from '../../../../types';
import { styles } from '../../../../styles';
import { DISABLED_ANSWERS } from '../../../../constants';
import { CommentContragentInfo } from './CommentContragentInfo';
import { theme } from '~/theme';
import { SystemStyleObject, Theme } from '@mui/system';

interface IAnswerCommentsProps {
  isBottomSpace: boolean;
  explanationIndex: number;
  questionId: number;
  answers: (TExplanationAnswer & Record<'id', string>)[];
}

export const AnswerComments = ({
  isBottomSpace,
  explanationIndex,
  questionId,
  answers,
}: IAnswerCommentsProps) => {
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  return (
    <Box
      sx={[
        styles.answerCommentsContainer as SystemStyleObject<Theme>,
        { mb: isBottomSpace && !isMobile ? 7 : 0 },
      ]}
    >
      {answers.map((answer: TExplanationAnswer & Record<'id', string>, index) => {
        return DISABLED_ANSWERS.includes(Number(answer.value)) ? (
          <Box sx={styles.disabledInfo} key={index}>
            <Typography variant="body2">Додаткова інформація заблокована</Typography>
          </Box>
        ) : questionId === 9 ? (
          <CommentContragentInfo
            key={index}
            answerIndex={index}
            explanationIndex={explanationIndex}
          />
        ) : (
          <FormInput
            key={index}
            variant="standard"
            name={`explanation.${explanationIndex}.answers.${index}.comments.0.general`}
            fullWidth
            errorTouchedOnly
            placeholder="Введіть значення"
            sx={styles.tableInput}
          />
        );
      })}
      {!answers.length && (
        <Box sx={styles.disabledInfo}>
          <Typography variant="body2">Оберіть варіант відповіді</Typography>
        </Box>
      )}
    </Box>
  );
};
